import { environment } from './../../environments/environment';

import { ApiService } from './../_services/api.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from '../_services/account.service';


@Injectable({providedIn: 'root'})
export class JwtInterceptor implements HttpInterceptor {

    constructor(
        private accountService: AccountService,
        private apiService: ApiService
        ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const user = this.accountService.userValue;
        const isLogged = user && user.token;    
        const isApiCall = req.url.startsWith(environment.apiUrl);
        if (isLogged && isApiCall) {
            req = req.clone( {
                setHeaders: {
                    Authorization: `Bearer ${user.token}`                    
                } 
            });
        }
        
        return next.handle(req);
    }
}
